var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.84 8.75333C11.02 8.75333 10.2267 8.62 9.48667 8.38C9.25333 8.3 8.99333 8.36 8.81333 8.54L7.76667 9.85333C5.88 8.95333 4.11333 7.25333 3.17333 5.3L4.47333 4.19333C4.65333 4.00667 4.70667 3.74667 4.63333 3.51333C4.38667 2.77333 4.26 1.98 4.26 1.16C4.26 0.8 3.96 0.5 3.6 0.5H1.29333C0.933333 0.5 0.5 0.66 0.5 1.16C0.5 7.35333 5.65333 12.5 11.84 12.5C12.3133 12.5 12.5 12.08 12.5 11.7133V9.41333C12.5 9.05333 12.2 8.75333 11.84 8.75333Z",
    fill: "#005996"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPhone);
export default __webpack_public_path__ + "static/media/icn_phone.b21dc184915e4c7c3262ba567c04d630.svg";
export { ForwardRef as ReactComponent };